import React from 'react';

import {Provider} from 'react-redux';

import {QueryClient, QueryClientProvider} from '@tanstack/react-query';
import {DndProvider} from 'react-dnd';
import {HTML5Backend} from 'react-dnd-html5-backend';
import {BrowserRouter} from 'react-router-dom';

import {HappifyThemeProvider} from '../components';
import {CountryProvider} from '../contexts/CountryContext';
import {AppRouter} from './AppRouter';
import store from './store';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
});

function App() {
  return (
    <Provider store={store}>
      <QueryClientProvider client={queryClient}>
        <CountryProvider>
          <HappifyThemeProvider>
            <BrowserRouter>
              <DndProvider backend={HTML5Backend}>
                <AppRouter />
              </DndProvider>
            </BrowserRouter>
          </HappifyThemeProvider>
        </CountryProvider>
      </QueryClientProvider>
    </Provider>
  );
}

export default App;
